module.exports = __webpack_public_path__ + "assets/img/index-partner36.00fc27a0.jpg";